import React, { Component } from 'react';
import { connect } from 'react-redux';
import Products from '../MenuComponents/Products/Products';
import Categories from '../MenuComponents/Categories/Categories';
import Aux from 'hoc/ReactAux/ReactAux';
import * as actions from 'actions/index';
import {
  closeModalErrorPlacedOrder,
  openModalReceiptOnCart,
  closeModalReceiptOnCart,
  closeModalPlacedOrderOnCart,
} from 'actions/Cart';
import ModalCartMessage from 'components/UI/Modal/ModalCartMessage';
import ModalErrorPlacedOrder from 'components/UI/Modal/ModalError';
import ModalSuccessPayment from 'components/UI/Modal/ModalSuccessPayment';
import ModalReceipt from 'components/UI/Modal/ModalReceipt';
import ModalErrorAvailableRestaurant from 'components/UI/Modal/ModalError';
import ProductsDetails from '../MenuComponents/Products/ProductDetails/ProductDetails';
import ErrorHandling from 'hoc/ErroHandling';
import Cart from '../Cart/Cart';
import objectUtils from 'utils/object';
import currencyUtils from 'utils/currency';

class DynamicMenu extends Component {
  state = {
    differentRestaurant: false,
    productStandyBy: null,
    showCategoriesMobile: false,
    isMobile: window.innerWidth <= 1024,
    handlingError: {
      showError: false,
      errorMessage: '',
    },
  };

  componentDidMount() {
    this.setState({
      differentRestaurant: false,
    });
    if (this.props.restaurantSelected !== null) {
      this.handleSelectFirstCategoryFromRestaurant();
    } else {
      this.props.history.replace('/Menu');
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.restaurantSelected !== this.props.restaurantSelected) {
      this.handleSelectFirstCategoryFromRestaurant();
    }
  }

  toggleCategoriesNavClass = () => {
    this.props.onToggleCart(false);
    this.props.onToggleRestaurants(false);
    this.setState({
      showCategoriesMobile: !this.state.showCategoriesMobile,
    });
  };

  toggleCart = () => {
    this.props.onToggleCart();
    this.props.onToggleRestaurants(false);
    this.setState({
      showCategoriesMobile: false,
    });
  };

  toggleRestaurants = () => {
    this.props.onToggleCart(false);
    this.props.onToggleRestaurants();
    this.setState({
      showCategoriesMobile: false,
    });
  };

  handleSelectFirstCategoryFromRestaurant = () => {
    if (
      this.props.restaurantSelected !== null &&
      this.props.restaurantSelected.categoryType
    ) {
      let idCategory =
        this.props.restaurantSelected.categoryType.length > 0
          ? this.props.restaurantSelected.categoryType[0].id
          : 0;
      this.handleSelectCategory(idCategory);
    }
  };

  handleSelectCategory = idCategory => {
    // this.props.onFetchingProducts(this.props.restaurantSelected.id, idCategory);

    this.props.onFetchingProducts(
      this.props.restaurantSelected != null
        ? this.props.restaurantSelected.id
        : 0,
      this.props.restaurantSelected != null ? idCategory : 0
    );
  };

  handleSelectProduct = idProduct => {
    if (this.props.restaurantSelected.isOpen) {
      let product = this.props.products.find(product => {
        return product.id === idProduct;
      });
      let isDiferrent = !this.props.restaurantOnCart
        ? false
        : this.props.restaurantOnCart.id !== this.props.restaurantSelected.id;
      this.setState({ differentRestaurant: isDiferrent });
      if (isDiferrent) {
        this.setState({ productStandBy: product });
      } else {
        this.verifyMealOptionsProduct(product);
      }
    } else {
      this.setState({
        handlingError: {
          showError: true,
          errorMessage: 'Sorry, This restaurant is already closed',
        },
      });
    }
  };

  handleConfirmOkCartModal = () => {
    this.props.onDeleteAllProductsFromCart();
    this.verifyMealOptionsProduct(this.state.productStandBy);
    this.setState({ differentRestaurant: false });
  };

  verifyMealOptionsProduct = product => {
    if (product.mealOptions && product.mealOptions.length > 0) {
      this.props.onSelectProduct(product);
    } else {
      this.props.onAddProductToCart({
        product: product,
        business: this.props.restaurantSelected,
      });
    }
  };

  getAmount() {
    return objectUtils.get(this.props, 'cart.payInfo.amount', 0);
  }

  getCurrency() {
    return currencyUtils.convertNameToSymbol(
      objectUtils.get(this.props, 'cart.restaurantSelected.currency', 'EUR')
    );
  }

  getSurcharge = () => {
    const isPayTypeCreditCard = payType => payType === 'C';
    const payType = objectUtils.get(
      this.props,
      'cart.payInfo.payType',
      undefined
    );
    if (isPayTypeCreditCard(payType)) {
      return objectUtils.get(this.props, 'cart.campaignRateCC.amount', 0);
    }
    return 0;
  };

  getSubTotal() {
    return objectUtils.get(this.props, 'cart.subtotal', 0);
  }

  getTaxDelivery = () => {
    return !!this.props.restaurantSelected &&
      this.props.restaurantSelected.taxDelivery &&
      this.isDeliverAtHome()
      ? this.props.restaurantSelected.taxDelivery.toFixed(2)
      : Number(0).toFixed(2);
  };

  getCollectionDiscount = () => {
    let campaignRateCollection = objectUtils.get(
      this.props,
      'cart.campaignRateCollection',
      null
    );
    if (campaignRateCollection) {
      let collectionDiscount =
        campaignRateCollection.discountType === 'P'
          ? `% ${campaignRateCollection.amount}`
          : `- ${campaignRateCollection.amount}`;
      return collectionDiscount;
    } else {
      return '';
    }
  };

  isForCollection = () => {
    return objectUtils.get(
      this.props,
      'cart.restaurantSelected.forCollection',
      'N'
    );
  };

  getReceiptData = () => {
    return {
      cart: this.props.cart,
      total: this.getAmount(),
      currency: this.getCurrency(),
      surcharge: this.getSurcharge(),
      subtotal: this.getSubTotal(),
      taxDelivery: this.getTaxDelivery(),
      userDetails: this.props.userDetails,
      orderDeliveryDate: objectUtils.get(
        this.props,
        'cart.orderDeliveryDate',
        undefined
      ),
      collectionDiscount: this.getCollectionDiscount(),
      forCollection: this.isForCollection(),
      address: this.getAddress(),
      tipValue: objectUtils.get(this.props, 'cart.tipValue', 0),
    };
  };

  handleDenyCartModal = () => {
    this.setState({ differentRestaurant: false });
  };

  handleCloseHandlingError = () => {
    this.setState({
      handlingError: { showError: false, errorMessage: '' },
    });
  };

  handleCloseModalPlacedOrderOnCart = () => {
    this.props.closeModalPlacedOrderOnCart(this.props.history);
  };
  handleCloseModalReceiptOnCart = () => {
    this.props.closeModalReceiptOnCart();
    this.props.history.replace('/Menu');
  };

  handleCloseModalNotAvailableRestaurant = () => {
    this.props.onFetchingMenu(this.props.userDetails.idBusiness);
    this.props.onCloseModalAvailableRestaurant();
    this.props.history.replace('/Menu');
  };

  handleCloseModalReceipt = () => {
    this.props.closeModalReceiptOnCart();
    this.props.history.replace('/Menu');
  };

  getAddress = () => {
    return this.props.addresses[0];
  };

  isDeliverAtHome = () => {
    return this.getAddress() != null
      ? this.getAddress().idCustomerDeliveryAddress != null
      : false;
  };

  getModalAvailableRestaurant = () => {
    let modalAvailableRestaurant =
      this.props.restaurantSelected &&
      this.props.restaurantSelected.isAvailable != null &&
      !this.props.restaurantSelected.isAvailable ? (
        <ModalErrorAvailableRestaurant
          showModal={
            this.props.restaurantSelected &&
            !this.props.restaurantSelected.isAvailable
          }
          errorMessage={'Sorry this restaurant is not available for you today!'}
          actionButton={this.handleCloseModalNotAvailableRestaurant}
          actionButtonTitle="Close"
          closeModal={this.handleCloseModalNotAvailableRestaurant}
        />
      ) : null;
    return modalAvailableRestaurant;
  };

  render() {
    return (
      <Aux>
        <ErrorHandling
          handlingError={this.state.handlingError}
          closedErrorModal={this.handleCloseHandlingError}
        >
          <ProductsDetails />
          <ModalCartMessage
            clickButtonConfirm={this.handleConfirmOkCartModal}
            clickButtonDeny={this.handleDenyCartModal}
            message={
              <strong>
                Note! You can only order from <br /> one restaurant at a time.
                <br />
                Clear current basket to add?
              </strong>
            }
            showModal={this.state.differentRestaurant}
          />
          <ModalErrorPlacedOrder
            style={{ zIndex: '99999', position: 'absolute', margin: '5% 40%' }}
            styleContent={{ background: 'gainsboro' }}
            closeModal={this.props.closeModalErrorPlacedOrder}
            showModal={this.props.modalErrorPlacedOrder}
            errorMessage={this.props.errorMessage}
          />
          {this.getModalAvailableRestaurant()}
          <ModalSuccessPayment
            descriptionSuccess={this.props.cart.descriptionSuccess}
            isInvoice={this.props.cart.isInvoice}
            closeModal={this.handleCloseModalPlacedOrderOnCart}
            showModal={this.props.showPlacedModal}
            openReceipt={this.props.openModalReceiptOnCart}
          />
          <ModalReceipt
            showModal={this.props.showReceiptModal}
            closeModal={this.handleCloseModalReceiptOnCart}
            data={this.getReceiptData()}
          />
          <div className="main-content">
            <Categories
              categoriesType={this.props.categoriesRestaurant}
              selectCategory={this.handleSelectCategory}
              showCategoriesMobile={this.state.showCategoriesMobile}
              toggleCategoriesNavClass={this.toggleCategoriesNavClass}
              showRestaurantsMobile={this.props.showRestaurantsMobile}
              toggleRestaurants={this.toggleRestaurants}
              isMobile={this.state.isMobile}
              checkout={this.props.checkout}
              toggleCart={this.toggleCart}
            />
            <Products
              isPopularDish={false}
              checkout={this.props.checkout}
              selectProduct={this.handleSelectProduct}
              products={this.props.products}
              business={this.props.restaurantSelected}
            />
            <Cart />
          </div>
        </ErrorHandling>
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    userDetails: state.authenticationReducer.userDetails,
    restaurantSelected: state.menuReducer.restaurantSelected,
    products: state.menuReducer.products,
    showRestaurantsMobile: state.menuReducer.showRestaurantsMobile,
    cart: state.cartReducer.cart,
    categoriesRestaurant: state.menuReducer.categoriesRestaurant,
    checkout: state.cartReducer.cart.checkout,
    showPlacedModal: state.cartReducer.cart.showPlacedModal,
    showReceiptModal: state.cartReducer.cart.showReceiptModal,
    restaurantOnCart: state.cartReducer.cart.restaurantSelected,
    modalErrorPlacedOrder: state.cartReducer.cart.modalErrorPlacedOrder,
    errorMessage: state.cartReducer.cart.errorLimit,
    addresses: state.menuReducer.addresses,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchingMenu: idBusiness => dispatch(actions.fetchingMenu(idBusiness)),
    onFetchingProducts: (idRestaurant, idCategory) =>
      dispatch(actions.fetchingProducts(idRestaurant, idCategory)),
    onSelectProduct: product => dispatch(actions.selectProduct(product)),
    onAddProductToCart: product => dispatch(actions.addProductToCart(product)),
    onDeleteAllProductsFromCart: () =>
      dispatch(actions.deleteAllProductsFromCart()),
    onToggleCart: state => dispatch(actions.toggleCart(state)),
    onToggleRestaurants: state => dispatch(actions.toggleRestaurants(state)),
    onCloseModalAvailableRestaurant: () =>
      dispatch(actions.closeModalAvailableRestaurant()),
    cartToggleShowModalReceipt: isClosing =>
      dispatch(actions.cartToggleShowModalReceipt(isClosing)),
    closeModalErrorPlacedOrder: () => dispatch(closeModalErrorPlacedOrder()),
    closeModalPlacedOrderOnCart: history =>
      dispatch(closeModalPlacedOrderOnCart(history)),
    closeModalReceiptOnCart: () => dispatch(closeModalReceiptOnCart()),
    openModalReceiptOnCart: () => dispatch(openModalReceiptOnCart()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicMenu);



// WEBPACK FOOTER //
// ./src/containers/Menu/DynamicMenu/DynamicMenu.js